import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import cn from 'classnames'
import styles from './auth.scss'

import {logIn, changeAuthState, appGetNofitications, createConfirmationToken} from 'state/actions'

import i18n from 'lib/i18n'
const _ = i18n('login')

@connect(state => ({
	errors: state.auth.errors,
	isPhone: state.responsive.isPhone,
	// hack to reload on translation load
	dict: state.dict,
	notifications: state.notifications.items,
	language: state.app.lang
}))
export default class LoginClient extends React.Component {

	componentWillMount() {
		const { dispatch } = this.props
		dispatch(appGetNofitications('client'))
	}

	loginClicked(ev) {
		ev.preventDefault()

		const {dispatch} = this.props
		const login = this.refs.login.value
		const password = this.refs.password.value

		dispatch(logIn(login, password))
	}
	registrationClicked() {
		const {dispatch} = this.props

		dispatch(changeAuthState('registration'))
	}
	resetPassword() {
		const {dispatch} = this.props

		dispatch(changeAuthState('passwordReset', {ok: false}))
	}


	/**
	 * Get the notification message based on current app language
	 *
	 * @param {object} notification item data
	 */
	getNotificationMessage(notification) {
		const { language } = this.props
		let languageKey = 'message' + this.capitalizeFirstLetter(language)

		return notification[languageKey]
	}

	/**
	 * Validates if the notification is not expired
	 *
	 * @param {object} notification item data
	 */
	isValidNotification(notification) {
		if(notification.length < 1) {
			return false
		}

		const item = notification[0]
		const currentDate = moment()
		const notificationExpires = moment(item.expires)

		if(currentDate.isBefore(notificationExpires)) {
			return true
		}

		return false
	}

	capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}

	render() {
		const {errors, isPhone, notifications} = this.props

		return (
			<div className={styles.authWrappNew}>
				<div className={styles.authFormsContainer}>
					<div className={styles.loginForm}>
						<div className={styles.formImage}>
							<img src={require("resources/easinsure/easinsure-logotype-slogan.svg")}/>
						</div>
						<form onSubmit={(ev) => this.loginClicked(ev)} method="post" className={styles.form} autoComplete="off">
                            <input autoComplete="off" name="hidden" type="text" style={{display: "none"}}/>
							<div className={styles.formGroup}>
								<label htmlFor="name">{_('email')}</label>
								<input ref="login" type="text" name="login"/>
							</div>
							<div className={styles.formGroup}>
								<label htmlFor="password">{_('password')}</label>
								<input ref="password" type="password" name="password" autoComplete="new-password"/>
							</div>
							<div className={styles.errorMessage}>
								{errors && _(errors.id)}
							</div>
							<div className={styles.formGroup}>
								<button type="submit" className={cn(styles.submitButton, 'client')}>{_('loginBttn')}</button>
							</div>
						</form>
						<div className={styles.formGroup}>
							<button onClick={() => this.registrationClicked()} className={styles.registerButton}>{_('registerBttn')}</button>
						</div>
					</div>
					<div id="casper_passForgotten" className={styles.additionalOption}>
						<a onClick={() => this.resetPassword()}>{_('passwordForgotten')}</a>
					</div>
				</div>
				{notifications && notifications.length > 0 && this.isValidNotification(notifications) &&
					<div className={styles.notificationWrapper}>
						<span>
							{notifications.map((notification, key ) => {
								return this.getNotificationMessage(notification)
							})}
						</span>
					</div>
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/auth/loginClient.jsx